import { types } from '../actions/uploadData';
import { addIdsToDataObject, cvPreParsing } from '../utils/dataParsers';
// eslint-disable-next-line import/named
import { sortArrayOfObjectsByDate, validatePBData } from '../utils/helpers';
import { validationMessages } from '../utils/constants';

const initialState = {
  pendingUpload: false,
  pendingParse: false,
  error: '',
  validationErrors: {
    JobExperienceDetails: [],
    EducationDetails: [],
    TrainingDetails: []
  },
  cvLink: '',
  parsedCV: {
    Skills: [],
    PersonalDetails: {
      Phone: '',
      PhoneCode: '',
      Country: '',
      State: '',
      City: ''
    },
    EducationDetails: [],
    TrainingDetails: [],
    JobExperienceDetails: [],
    JobPreferences: {
      industry: [],
      jobs: []
    },
    JobsFilters: {
      contract: {
        contrActive: false,
        hourly: '',
        daily: '',
        currency: ''
      },
      permanent: {
        permActive: false,
        salary: '',
        currency: ''
      },
      relocationWork: false,
      remoteWork: false
    }
  }
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.CV_OVERSIZE:
      return {
        ...state,
        error: action.payload ? validationMessages(state.i18next.t).CV_ALLOWED_FILE_SIZE : ''
      };
    case types.CV_UPLOAD_FULFILLED:
      return { ...state, pendingUpload: false, error: '', cvLink: action.payload?.Data };
    case types.CV_PARSE_FULFILLED:
      // eslint-disable-next-line no-case-declarations
      const dataWithIds = addIdsToDataObject(action.payload?.Data);
      return {
        ...state,
        pendingParse: false,
        error: '',
        validationErrors: validatePBData(dataWithIds),
        parsedCV: {
          ...action.payload?.Data,
          JobExperienceDetails: cvPreParsing(dataWithIds, 'JobExperienceDetails'),
          EducationDetails: cvPreParsing(dataWithIds, 'EducationDetails', true),
          TrainingDetails: cvPreParsing(dataWithIds, 'TrainingDetails'),
          Skills: action.payload.Data.Skills.map((skill) => ({ Name: skill.Name, TopSkill: false })),
          PersonalDetails: {
            ...action.payload.Data.PersonalDetails,
            City: '',
            State: '',
            Country: ''
          },
          JobPreferences: {
            industry: [],
            jobs: []
          },
          JobsFilters: state.parsedCV.JobsFilters
        }
      };
    case types.CV_UPLOAD_PENDING:
      return { ...state, pendingUpload: true, error: '' };
    case types.CV_PARSE_PENDING:
      return { ...state, pendingParse: true, error: '' };
    case types.CV_UPLOAD_REJECTED:
      return { ...state, pendingUpload: false, error: action.payload.message };
    case types.CV_PARSE_REJECTED:
      return { ...state, pendingParse: false, error: action.payload.message };
    case types.CV_UPDATE:
      switch (action.payload.flag) {
        case 'WorkAdd':
          // eslint-disable-next-line no-case-declarations
          const withAddedWork = sortArrayOfObjectsByDate(
            [...state.parsedCV.JobExperienceDetails, action.payload.value],
            'EndDate',
            'CurrentlyWorkThere',
            'StartDate'
          );
          return {
            ...state,
            validationErrors: validatePBData({
              JobExperienceDetails: withAddedWork,
              EducationDetails: state.parsedCV.EducationDetails
            }),
            parsedCV: {
              ...state.parsedCV,
              JobExperienceDetails: withAddedWork
            }
          };
        case 'WorkDelete':
          // eslint-disable-next-line no-case-declarations
          const withoutDeletedWork = state.parsedCV.JobExperienceDetails.filter(
            (item) => item.id !== action.payload.value
          );
          return {
            ...state,
            validationErrors: validatePBData({
              JobExperienceDetails: withoutDeletedWork,
              EducationDetails: state.parsedCV.EducationDetails
            }),
            parsedCV: {
              ...state.parsedCV,
              JobExperienceDetails: withoutDeletedWork
            }
          };
        case 'WorkUpdate':
          // eslint-disable-next-line no-case-declarations
          const withUpdatedWork = sortArrayOfObjectsByDate(
            state.parsedCV.JobExperienceDetails.map((item) =>
              item.id !== action.payload.value.id ? item : action.payload.value
            ),
            'EndDate',
            'CurrentlyWorkThere',
            'StartDate'
          );
          return {
            ...state,
            validationErrors: validatePBData({
              JobExperienceDetails: withUpdatedWork,
              EducationDetails: state.parsedCV.EducationDetails
            }),
            parsedCV: {
              ...state.parsedCV,
              JobExperienceDetails: withUpdatedWork
            }
          };
        case 'EducationAdd':
          // eslint-disable-next-line no-case-declarations
          const withAddedEdu = sortArrayOfObjectsByDate(
            [...state.parsedCV.EducationDetails, action.payload.value],
            'EndDate',
            'CurrentlyStudyHere',
            'StartDate'
          );
          return {
            ...state,
            validationErrors: validatePBData({
              JobExperienceDetails: state.parsedCV.JobExperienceDetails,
              EducationDetails: withAddedEdu
            }),
            parsedCV: {
              ...state.parsedCV,
              EducationDetails: withAddedEdu
            }
          };
        case 'EducationDelete':
          // eslint-disable-next-line no-case-declarations
          const withoutDeletedEdu = state.parsedCV.EducationDetails.filter((item) => item.id !== action.payload.value);
          return {
            ...state,
            validationErrors: validatePBData({
              JobExperienceDetails: state.parsedCV.JobExperienceDetails,
              EducationDetails: withoutDeletedEdu
            }),
            parsedCV: {
              ...state.parsedCV,
              EducationDetails: withoutDeletedEdu
            }
          };
        case 'EducationUpdate':
          // eslint-disable-next-line no-case-declarations
          const withUpdatedEdu = sortArrayOfObjectsByDate(
            state.parsedCV.EducationDetails.map((item) =>
              item.id !== action.payload.value.id ? item : action.payload.value
            ),
            'EndDate',
            'CurrentlyStudyHere',
            'StartDate'
          );
          return {
            ...state,
            validationErrors: validatePBData({
              JobExperienceDetails: state.parsedCV.JobExperienceDetails,
              EducationDetails: withUpdatedEdu
            }),
            parsedCV: {
              ...state.parsedCV,
              EducationDetails: withUpdatedEdu
            }
          };
        case 'TrainingAdd':
          return {
            ...state,
            parsedCV: {
              ...state.parsedCV,
              TrainingDetails: [...state.parsedCV.TrainingDetails, action.payload.value]
            }
          };
        case 'TrainingDelete':
          return {
            ...state,
            parsedCV: {
              ...state.parsedCV,
              TrainingDetails: state.parsedCV.TrainingDetails.filter((item) => item.id !== action.payload.value)
            }
          };
        case 'TrainingUpdate':
          return {
            ...state,
            parsedCV: {
              ...state.parsedCV,
              TrainingDetails: state.parsedCV.TrainingDetails.map((item) =>
                item.id !== action.payload.value.id ? item : action.payload.value
              )
            }
          };
        case 'Personal':
          return {
            ...state,
            parsedCV: {
              ...state.parsedCV,
              PersonalDetails: action.payload.value
            }
          };
        case 'industry':
          return {
            ...state,
            parsedCV: {
              ...state.parsedCV,
              JobPreferences: {
                ...state.parsedCV.JobPreferences,
                industry: action.payload.value
              }
            }
          };
        case 'jobs':
          return {
            ...state,
            parsedCV: {
              ...state.parsedCV,
              JobPreferences: {
                ...state.parsedCV.JobPreferences,
                jobs: action.payload.value
              }
            }
          };
        case 'Relocation':
          return {
            ...state,
            parsedCV: {
              ...state.parsedCV,
              JobsFilters: {
                ...state.parsedCV.JobsFilters,
                relocationWork: !state.parsedCV.JobsFilters.relocationWork
              }
            }
          };
        case 'Remote':
          return {
            ...state,
            parsedCV: {
              ...state.parsedCV,
              JobsFilters: {
                ...state.parsedCV.JobsFilters,
                remoteWork: !state.parsedCV.JobsFilters.remoteWork
              }
            }
          };
        case 'Contract':
          return {
            ...state,
            parsedCV: {
              ...state.parsedCV,
              JobsFilters: {
                ...state.parsedCV.JobsFilters,
                contract: {
                  ...initialState.parsedCV.JobsFilters.contract,
                  contrActive: !state.parsedCV.JobsFilters.contract.contrActive
                }
              }
            }
          };
        case 'Permanent':
          return {
            ...state,
            parsedCV: {
              ...state.parsedCV,
              JobsFilters: {
                ...state.parsedCV.JobsFilters,
                permanent: {
                  ...initialState.parsedCV.JobsFilters.permanent,
                  permActive: !state.parsedCV.JobsFilters.permanent.permActive
                }
              }
            }
          };
        case 'Preferences':
          return {
            ...state,
            parsedCV: {
              ...state.parsedCV,
              JobsFilters: {
                ...state.parsedCV.JobsFilters,
                permanent: {
                  ...state.parsedCV.JobsFilters.permanent,
                  salary: action.payload.value.salary,
                  currency: action.payload.value.currency
                },
                contract: {
                  ...state.parsedCV.JobsFilters.contract,
                  hourly: action.payload.value.hourly,
                  daily: action.payload.value.daily,
                  currency: action.payload.value.currency
                }
              }
            }
          };
        default:
          return state;
      }
    case types.CV_ADD_SKILL:
      if (action.payload)
        return {
          ...state,
          parsedCV: {
            ...state.parsedCV,
            Skills: action.payload
          }
        };
      return state;
    case types.CV_DELETE_SKILL:
      return {
        ...state,
        parsedCV: {
          ...state.parsedCV,
          Skills: state.parsedCV.Skills.filter((skill) => skill.Name !== action.payload)
        }
      };
    case types.CV_CHANGE_TOP_SKILL:
      return {
        ...state,
        parsedCV: {
          ...state.parsedCV,
          Skills: state.parsedCV.Skills.map((skill) =>
            skill.Name !== action.payload ? skill : { ...skill, TopSkill: !skill.TopSkill }
          )
        }
      };
    case types.RESTORE_AFTER_REFRESH:
      return {
        ...state,
        validationErrors: validatePBData({
          JobExperienceDetails: action.payload?.JobExperienceDetails,
          EducationDetails: action.payload?.EducationDetails
        }),
        parsedCV: action.payload
      };

    default:
      return state;
  }
}
